import React from 'react';
import { useInterviewStore } from '../stores/interviewStore';
import styles from '../styles/JobDescriptionModal.module.css';
import { useUiCopy } from '../i18n/useUiCopy';

const JobDescriptionModal: React.FC = () => {
  const showJobDescriptionModal = useInterviewStore(state => state.ui.showJobDescriptionModal);
  const jobDescription = useInterviewStore(state => state.session.jobDescription);
  const hideJobDescription = useInterviewStore(state => state.hideJobDescription);
  const copy = useUiCopy();

  if (!showJobDescriptionModal) {
    return null;
  }

  return (
    <div className={styles.modalOverlay} onClick={hideJobDescription}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>{copy.jobDescriptionTitle}</h2>
          <button className={styles.closeButton} onClick={hideJobDescription}>
            &times;
          </button>
        </div>
        <div className={styles.modalBody}>
          <div dangerouslySetInnerHTML={{ __html: jobDescription }} />
        </div>
      </div>
    </div>
  );
};

export default JobDescriptionModal;
